"use strict";

module.exports = /*@ngInject*/function () {
  return {
    restrict: 'AE',
    scope: true,
    bindToController: {
      id: '@',
      form: '=',
      campusCode: '@',
      model: '=ngModel',
      ngRequired: '=ngRequired',
      ngDisabled: '=ngDisabled',
      showError: '=showError'
    },
    templateUrl: 'shared/components/building-search/building.search.html',
    controllerAs: 'sCtrl',
    // eslint-disable-next-line func-names, object-shorthand
    controller: /*@ngInject*/function controller(PersonService, ProfileService, LocationService, ConfigService) {
      var sCtrl = this;
      var _ConfigService$getCon = ConfigService.getConfig(),
        PROFILE_URL = _ConfigService$getCon.PROFILE_URL;
      sCtrl.helpText = "<ol class='help-steps'><li>Add building/floor by logging into <a href='".concat(PROFILE_URL, "' target='_blank'>Profile</a>.</li><li> If you continue to experience problems searching for a building/floor, please contact the Service Desk at <a href='mailto:service@RiskandSafetySolutions.com'>service@RiskandSafetySolutions.com</a></li></ol>");
      sCtrl.model = sCtrl.model || {};
      sCtrl.buildings = [];
      sCtrl.selectedBuilding = {};
      sCtrl.currentUser = ProfileService.getProfile();
      sCtrl.campusCode = sCtrl.campusCode || sCtrl.currentUser.campusCode;
      sCtrl.noBuildingResults = false;
      sCtrl.loadingBuildings = false;
      sCtrl.noFloorResults = false;
      sCtrl.loadingFloors = false;
      sCtrl.selectedBuilding = null;
      sCtrl.selectedFloor = null;
      sCtrl.init = function () {
        sCtrl.loadingBuildings = true;
        LocationService.getCampusBuildings({
          campusCode: sCtrl.campusCode
        }).$promise.then(function (result) {
          sCtrl.loadingBuildings = false;
          sCtrl.buildings = result;
          if (sCtrl.model && sCtrl.model.buildingId) {
            sCtrl.selectedBuilding = result.find(function (building) {
              return building.buildingId === sCtrl.model.buildingId;
            });
            sCtrl.getBuildingDetails(sCtrl.selectedBuilding);
          }
        })["catch"](function () {
          sCtrl.loadingBuildings = false;
          sCtrl.buildings = [];
        });
      };
      sCtrl.getBuildingDetails = function (building) {
        sCtrl.model.buildingId = building.buildingId;
        sCtrl.loadingFloors = true;
        if (building) {
          LocationService.getBuildingDetails({
            campusCode: sCtrl.campusCode,
            buildingId: building.buildingId
          }).$promise.then(function (result) {
            sCtrl.loadingFloors = false;
            sCtrl.selectedBuilding = result;
            if (result.floors && sCtrl.model && sCtrl.model.floorId) {
              sCtrl.selectedFloor = result.floors.find(function (floor) {
                return floor.floorId === sCtrl.model.floorId;
              });
            }
          })["catch"](function () {
            sCtrl.loadingFloors = false;
          });
        } else {
          sCtrl.loadingFloors = false;
          sCtrl.selectedBuilding = undefined;
        }
      };
      sCtrl.clearSelectedBuilding = function () {
        sCtrl.model.buildingId = null;
        sCtrl.selectedBuilding = undefined;
        sCtrl.clearSelectedFloor();
      };
      sCtrl.selectFloor = function (floor) {
        sCtrl.model.floorId = floor.floorId;
      };
      sCtrl.clearSelectedFloor = function () {
        sCtrl.model.floorId = null;
        sCtrl.selectedFloor = undefined;
      };
    }
  };
};